import React from "react";
import {Snackbar} from "@mui/material";
import {useTheme} from "../../../../contexts/theme";

const ErrorSnackBar= ({open, autoHideDuration, errorMessage, setClose}) => {

    const theme = useTheme();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setClose();
    };

    return (
        <Snackbar

            anchorOrigin={theme.snackbarPosition}
            open={open}
            autoHideDuration={autoHideDuration}
            message={errorMessage}
            onClose={handleClose}
        />
    );
};

export default ErrorSnackBar;